import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { supabase } from "./supabase";
import MainPage from "./pages/MainPage";
import LoginPage from "./pages/LoginPage";
import MyPage from "./pages/MyPage";
import ArchivePage from "./pages/ArchivePage";
import SharePage from "./pages/SharePage";
import InquiryPage from "./pages/InquiryPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentHistoryPage from "./pages/PaymentHistoryPage";
import AdminPage from "./pages/AdminPage";

const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&family=Noto+Sans+KR:wght@400;500;700;900&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { min-height: 100%; background: #f0f0f0; font-family: 'DM Mono', monospace; -webkit-font-smoothing: antialiased; overflow-y: scroll; }
  input[type=range] { -webkit-appearance: none; appearance: none; width: 100%; height: 6px; border-radius: 3px; outline: none; cursor: pointer; }
  input[type=range]::-webkit-slider-thumb { -webkit-appearance: none; width: 22px; height: 22px; border-radius: 50%; background: #111111; cursor: pointer; box-shadow: 0 2px 6px rgba(0,0,0,0.3); }
  input[type=range]::-moz-range-thumb { width: 22px; height: 22px; border-radius: 50%; background: #111111; cursor: pointer; border: none; }
  textarea { font-family: 'DM Mono', monospace; }
  input { font-family: 'DM Mono', monospace; }
  button { font-family: 'DM Mono', monospace; }
  textarea:focus, input:focus { outline: none; }
  @keyframes fadeInUp { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
  @keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }
  .dd-item:hover { background: #f5f5f5 !important; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 2px; }
`;

export default function App() {
  const [user, setUser] = useState(null);
  const [credits, setCredits] = useState(null);

  const fetchCredits = async (userId) => {
    const { data } = await supabase
      .from('user_credits')
      .select('credits')
      .eq('id', userId)
      .single();
    setCredits(data?.credits ?? 0);
  };

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchCredits(session.user.id);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchCredits(session.user.id);
      else setCredits(null);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <>
      <style>{globalCSS}</style>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage user={user} credits={credits} fetchCredits={fetchCredits} />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/my" element={<MyPage user={user} credits={credits} onLogout={() => { setUser(null); setCredits(null); }} />} />
          <Route path="/archive" element={<ArchivePage user={user} />} />
          <Route path="/share/:id" element={<SharePage />} />
          <Route path="/inquiry/:type" element={<InquiryPage user={user} />} />
          <Route path="/payment" element={<PaymentPage user={user} fetchCredits={fetchCredits} />} />
          <Route path="/payment/success" element={<PaymentSuccessPage fetchCredits={fetchCredits} />} />
          <Route path="/payment/history" element={<PaymentHistoryPage user={user} />} />
          <Route path="/admin" element={<AdminPage user={user} />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}